import { motion } from 'framer-motion';
import { Check } from '@/components/icons';
import { cn } from '@/lib/utils';

/**
 * 비주얼 스테퍼 — 번호 원 + 연결선 + 짧은 이름.
 *
 *   ● 완료: 초록(#18BB69) 바탕에 체크    ● 현재: 검정 바탕에 번호    ○ 남음: 회색 테두리에 번호
 *
 * 연결선은 완료한 구간만 초록으로 차오른다. 정체성 정하기가 쓰고, 다른 다단계 화면도 같은 것을 쓴다.
 */
export function Stepper({ steps, current, className }: { steps: string[]; current: number; className?: string }) {
  return (
    <ol className={cn('flex items-start', className)} aria-label="진행 단계">
      {steps.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <li key={label} className={cn('flex min-w-0 items-start', i < steps.length - 1 && 'flex-1')}>
            <div className="flex w-12 shrink-0 flex-col items-center">
              <motion.div
                aria-current={active ? 'step' : undefined}
                initial={false}
                animate={{ scale: active ? 1.1 : 1 }}
                transition={{ type: 'spring', stiffness: 400, damping: 22 }}
                className={cn(
                  'flex size-8 items-center justify-center rounded-full border text-sm font-semibold transition-colors',
                  done && 'border-[#18BB69] bg-[#18BB69] text-white',
                  active && 'border-gray-900 bg-gray-900 text-white',
                  !done && !active && 'border-gray-300 bg-white text-gray-400',
                )}
              >
                {done ? <Check className="size-3.5" /> : i + 1}
              </motion.div>
              <span
                className={cn(
                  'mt-1.5 whitespace-nowrap text-[11px] font-medium',
                  active ? 'text-gray-900' : done ? 'text-[#18BB69]' : 'text-gray-400',
                )}
              >
                {label}
              </span>
            </div>
            {i < steps.length - 1 ? (
              <div className="relative mt-4 h-0.5 flex-1 rounded bg-gray-200" aria-hidden>
                <motion.div
                  className="absolute inset-y-0 left-0 rounded bg-[#18BB69]"
                  initial={false}
                  animate={{ width: done ? '100%' : '0%' }}
                  transition={{ duration: 0.35, ease: 'easeOut' }}
                />
              </div>
            ) : null}
          </li>
        );
      })}
    </ol>
  );
}
